import React, { useContext, useState, ReactNode } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import SubNavigation from 'components/SubNavigation/SubNavigation';
import PerformanceSummary from './PerformanceSummary';
import View from './View';
import Concerts from './Concerts';
import Physical from '../Overview/Physical';

import { overviewSubTopics } from 'topics';
import { IEntityPageComponentProps } from 'pages/Entity/shared';
import { EntityContext } from 'context/entityContext';
import TopicFilters from 'components/TopicFilters/TopicFilters';
import { SalesTypes } from 'context/entityContext';

const Overview: React.FC<IEntityPageComponentProps> = (props) => {
  const { match, pathPrefix } = props;
  const { entities } = match.params;

  const { compareMode, entityType, topic } = useContext(EntityContext);

  const [selectedSalesType, setSelectedSalesType] = useState<SalesTypes>();

  return (
    <>
      <SubNavigation topic="overview" variants={overviewSubTopics} />
      <TopicFilters
        topic={topic[1] || topic[0]}
        compareMode={compareMode}
        selectedSalesType={selectedSalesType}
        entityType={entityType}
      />
      <Switch>
        <Route
          exact
          path={`${pathPrefix}/artist/${entities}/overview/summary`}
          render={(): ReactNode => <PerformanceSummary />}
        />

        <Route
          exact
          path={`${pathPrefix}/artist/:entityIds(${entities})/overview/view`}
          render={(): any => (
            <View setSelectedSalesType={setSelectedSalesType} />
          )}
        />
        <Redirect
          exact
          from={`${pathPrefix}/artist/${entities}/overview/certifications`}
          to={`${pathPrefix}/artist/${entities}/overview/summary`}
        />
        <Route
          exact
          path={`${pathPrefix}/artist/${entities}/overview/concerts`}
          render={(): any => <Concerts />}
        />
        <Route
          exact
          path={`${pathPrefix}/artist/${entities}/overview/physical`}
          render={(): ReactNode => <Physical />}
        />
      </Switch>
    </>
  );
};

export default Overview;
